// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"AddressPoint__cursor-pointer--o34tghww","icMap":"AddressPoint__ic-map--YTvsJFj0"};